import React from 'react';

const CallForPresenters = () => (
  <section id="one" className="tiles whatIsMomentumTiles">
    <article>
      <header className="major">
        <h3>Call for proposals reopened!</h3>
      </header>
      <p>
        Apply to speak at Momentum now through June 21st. Get your talks in now
        through the end of the month to be considered for presenting at Momentum
        in October. We are expecting a large pool of applicants, so bring your
        best ideas forward.
        <a href="https://sessionize.com/momentum-2020/" style={{ marginLeft: '4px' }}>
          Submit your proposal today!
        </a>
      </p>
    </article>
  </section>
)

export default CallForPresenters;
